import { useRouter } from 'next/router';
import React, { useCallback } from 'react';
import { useFileStore } from 'src/features/files';

import { EmbedInput } from './EmbedInput';

const EmbedIframe = ({ iframeUrl }: { iframeUrl: string }) => (
  <div className="h-full w-full pt-42 embed-view">
    <iframe
      src={iframeUrl}
      style={{ height: 'calc(100vh - 92px)' }}
      className="w-full h-full"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    ></iframe>
  </div>
);

export const EmbedView = ({ id }: { id: string }) => {
  const router = useRouter();

  const currentFiles = useFileStore(
    useCallback((s) => s.files[router.query.slug as string], [router.query.slug as string])
  );
  const isPrimary = currentFiles?.primaryFile?.id === router.query.view;

  const currentView = currentFiles?.internalFiles?.find((view) => view.id === id);

  const onUpdateEmbedUrl = useFileStore((s) => s.onUpdateEmbedUrl);
  const url = isPrimary ? currentFiles?.primaryFile?.data?.url : currentView?.data?.url;
  const onSetUrl = (url: string) => {
    if (router.query.view) onUpdateEmbedUrl(router.query.slug as string, id, url);
  };

  return (
    <div className="bg-white">
      {url ? (
        <EmbedIframe iframeUrl={url} />
      ) : (
        <div className="flex justify-center pt-164">
          <EmbedInput onSubmit={onSetUrl} />
        </div>
      )}
    </div>
  );
};
